export const NETWORK_RETRY_ERRORS = [
  "ECONNABORTED",
  "ECONNREFUSED",
  "ECONNRESET",
  "ENOTFOUND",
  "EHOSTDOWN",
  "EHOSTUNREACH",
  "ENETDOWN",
  "ENETRESET",
  "ENETUNREACH",
  "EPIPE",
  "ETIMEDOUT",
  "ERR_NETWORK",
];

export const HTTP_RETRY_ERRORS = [409, 502, 503, 504, 429];

export const GET_GRANTS_API_LIMIT = 200;

export const ATHNAHEALTH_LOGO_SRC_URL =
  "https://ok4static.oktacdn.com/fs/bco/1/fs0ooyll75YvVs2ed1t7";

export const TERMS_OF_USE_URL =
  "https://www.athenahealth.com/resources/patient-facing-applications-terms-of-use";

export const PRIVACY_POLICY_URL =
  "https://www.athenahealth.com/resources/privacy-notice-for-patient-facing-applications";

/**
 * Okta reports the same factor under different `factorType` strings depending on
 * the endpoint — e.g. an enrolled Passkey is "security_key" from the enrolled
 * factors API but "webauthn" from the available-factors catalog. Enrolled TOTP
 * is "app", while the catalog uses "token:software:totp" and
 * `authenticatorInfo` uses "google_otp".
 * Maps each raw value to one canonical key so the factor maps and the blacklist
 * need only a single entry per factor.
 */
export const FACTOR_TYPE_ALIASES: { [rawFactorType: string]: string } = {
  security_question: "question",
  security_key: "webauthn",
  app: "google_otp",
  "token:software:totp": "google_otp",
};

/** Resolves a raw Okta `factorType` to its canonical key. */
export const normalizeFactorType = (factorType: string): string =>
  FACTOR_TYPE_ALIASES[factorType] || factorType;

export const factorDisplayNameMap: { [key: string]: string } = {
  question: "managefactors.factor.displayname.question",
  phone: "managefactors.factor.displayname.phone",
  webauthn: "managefactors.factor.displayname.webauthn",
  google_otp: "managefactors.factor.displayname.google_otp",
};

export const factorIconMap: { [key: string]: string } = {
  question: "mfa-okta-security-question",
  phone: "mfa-okta-phone",
  webauthn: "mfa-webauthn",
  google_otp: "mfa-totp",
};

export const factorDescriptionMap: { [key: string]: string } = {
  question: "managefactors.factor.description.question",
  phone: "managefactors.factor.description.phone",
  webauthn: "managefactors.factor.description.webauthn",
  google_otp: "managefactors.factor.description.google_otp",
};

export const MAX_PHONE_FACTOR_ALLOWED = 10;
export const MAX_WEBAUTHN_FACTOR_ALLOWED = 10;

export const MFA_FACTORS_BLACK_LIST = ['email', 'password'];

export const MIN_PASSWORD_LENGTH = 15;
export const MAX_PASSWORD_LENGTH = 72;

export const CURRENT_PASSWORD_INPUT_CONTEXT = "current-password";

export const NEW_PASSWORD_INPUT_CONTEXT = "new-password";

export const OKTA_API_ERROR_CODE_SUMMARY_MAP: Record<
  string,
  Record<string, Record<string, string>>
> = {
  E0000014: {
    "Password requirements were not met. Password requirements: at least 15 characters, no parts of your username, does not include your first name, does not include your last name. Your password cannot be any of your last 30 password(s).":
      {
        i18nkey: "editpassword.passwordrequirementnotmet.error",
        inputContext: NEW_PASSWORD_INPUT_CONTEXT,
      },
    "Old Password is not correct": {
      i18nkey: "editpassword.incorrectcurrentpassword.error",
      inputContext: CURRENT_PASSWORD_INPUT_CONTEXT,
    },
    "Password has been used too recently": {
      i18nkey: "editpassword.nohistorypassword.error",
      inputContext: NEW_PASSWORD_INPUT_CONTEXT,
    },
    "This password was found in a list of commonly used passwords. Please try another password.": {
      i18nkey: "editpassword.noweakpassword.error",
      inputContext: NEW_PASSWORD_INPUT_CONTEXT,
    },
  },
  ERR_NETWORK: {
    "Network Error": {
      i18nkey: "app.networkerrormessage",
    },
  },
};
